import React from 'react';
import styled from 'styled-components';
import LoadingIndicator from '../../components/LoadingIndicator';
import Constants from '../../submodules/logictry_config/constants';
import SidebarService from '../../services/SidebarService';
import Navigation from '../../services/Navigation';
import GrayOut from '../../services/TreeDisplay';
import UserAccount from '../../services/UserAccount';
import Company from '../../services/Company';
import AutoSaveTree from '../../services/AutoSaveTree';
import WindowSize from '../../services/WindowSize';
import Connect from '../../services/Connect';
import TreeCache from '../../services/cache/TreeCache';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent/index';
import TreeAnswerBox from './TreeAnswerBox';
import SaveTreeAndSubtrees from '../../utils/TreeParsers/SaveTreeAndSubtrees';
import Sidebar from './Sidebar';
import TextView from './TextView';
import LoggedOutSavePopup from './LoggedOutSavePopup';
import { findForceIframeContent } from '../../models/nodetypes';
import CreateProject from '../../services/CreateProject';
import { PropTypes } from 'prop-types';
import ChatInterface from '../../components/ChatInterface';
import { isEmailInvalid } from '../../utils/regex';
import { loadFont } from '../../utils/fonts';
import EmbedFullscreenButton from '../../components/EmbedFullscreenButton';
import { ArrowLeftIcon, ChatIcon, TreeIcon } from '../../styledhtml/Icon';
import checkContentType from '../../utils/checkContentType';
import EnterPassword from '../../components/EnterPassword';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Wrapper = styled.div`
  h1 {
    font-size: ${props => props.fontSizeH1};
  }
  h2 {
    font-size: ${props => props.fontSizeH2};
  }
  h3 {
    font-size: ${props => props.fontSizeH3};
  }
`;
const ContentWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;
const EditingDisabled = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  color: white;
  background-color: rgba(0,0,0,0.08);
  > div {
    box-shadow: rgb(0 0 0 / 30%) 0px 0px 4px 0px;
    background-color: ${Constants.PrimaryColor};
    position: absolute;
    width: 100%;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    height: 2rem;
    line-height: 2rem;
    > div {
      color: white;
      font-weight: bold;
      font-size: ${Constants.SemiSmallFontSize};
    }
  }
`;
const BackArrowWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  top: 8px;
  z-index: 2;
  background-color: ${Constants.White};
  border-radius: 4px;
  box-shadow: 0 1px 5px rgba(0,0,0,0.65);
`;


let backgroundColor;
let backgroundColorTimeout;

export default class TreeAnswerPage extends LogictryComponent {
  static propTypes = {
    fullscreen: PropTypes.bool,
    showAppId: PropTypes.string,
    onScroll: PropTypes.func,
  }
  constructor(props) {
    super(props);
    SidebarService.updateSelectType(Navigation.currentSearch.showchatbot === 'true' ? 'Chat' : 'Tree');
    Connect.__iframe = document.createElement('iframe');
    Connect.__iframe.style.position = 'absolute';
    Connect.__iframe.style.inset = '0';
    Connect.__iframe.style.width = '100%';
    Connect.__iframe.style.height = '100%';
    Connect.__iframe.style.border = '0px';
  }
  state = {
    autocreating: false,
    submitEmail: false,
    skipToReport: false,
    loading: true,
    password: '',
    chatbuttonShowContent: false,
  }
  componentDidMount() {
    WindowSize.onStateUpdate(this);
    Connect.onStateUpdate(this);
    SidebarService.onStateUpdate(this.updateState);
    TreeCache.onStateUpdate(this.treeCacheUpdated);
    UserAccount.onStateUpdate(this.treeCacheUpdated);
    this.treeCacheUpdated();
    setTimeout(() => {
      clearTimeout(backgroundColorTimeout);
    }, 20);
  }
  componentWillUnmount() {
    WindowSize.offStateUpdate(this);
    Connect.offStateUpdate(this);
    SidebarService.offStateUpdate(this.updateState);
    TreeCache.offStateUpdate(this.treeCacheUpdated);
    UserAccount.offStateUpdate(this.treeCacheUpdated);
    const { tree } = this.state;
    if (tree && tree._id) {
      tree.offStateUpdate(this.treeUpdated);
    }
    backgroundColorTimeout = setTimeout(() => { backgroundColor = null; }, 500);
  }
  handleClick = () => {
    const { isWidget } = Constants;
    if (!isWidget) return;
    if (Navigation.currentSearch.onclickshowfullscreen !== 'true') return;
    if (Connect.isFullscreen) return;
    Connect.toggleFullscreen();
  }
  get treeIdToGet() {
    const { showAppId } = this.props;
    if (showAppId) return showAppId;
    if (Navigation.currentLocation[1] === 'apps' && Navigation.currentLocation[2]) return Navigation.currentLocation[2];
    return null;
  }
  treeCacheUpdated = () => {
    const { isLoggedIn, account } = UserAccount;
    const { isWidget, apikey } = Constants;
    const { currentSearch } = Navigation;
    const { password, pwd } = currentSearch;
    let { tree } = this.state;
    const { treeIdToGet } = this;
    if (tree && tree._id) tree.offStateUpdate(this.treeUpdated);
    if (!treeIdToGet || treeIdToGet.startsWith('http')) return this.forceUpdate();
    tree = TreeCache.getTree(treeIdToGet, null, null, null, password || pwd, isWidget && apikey);
    if (!tree || tree.error) return this.setState({ tree, autocreating: false });
    if (tree.project && this.state.tree !== tree) {
      this.state.loading = true;
      if (Object.hasOwnProperty.call(currentSearch, 'autocreate')) {
        Navigation.getQueryParameter('autocreate');
      } else if (tree.progress && tree.progress.report || !(isLoggedIn && account._id === tree.owner)) {
        this.state.skipToReport = true;
      }
    } else if (tree.template && this.state.tree !== tree) {
      this.state.loading = true;
      CreateProject.initialize();
    }
    this.state.tree = tree;
    GrayOut.setTree(tree);
    tree.onStateUpdate(this.treeUpdated);

    if (tree.root && tree.root.fontFamily) {
      loadFont(tree.root.fontFamily)
    }

    // Check if autocreate exists
    if (tree.template && Object.hasOwnProperty.call(currentSearch, 'autocreate') && !this.state.autocreating) {
      this.state.autocreating = true;
      this.saveChanges();
      return this.forceUpdate();
    }

    this.state.autocreating = false;
    this.treeUpdated();
    return this.forceUpdate();
  }
  saveProgress = () => {
    SidebarService.updateSelectType('Email', true);
  }
  saveChanges = (email) => {
    const { selectType } = SidebarService;
    const { team } = Navigation.currentSearch;
    const { tree, autocreating } = this.state;
    const { isSavingProjectsAllowed } = tree;
    if (team) tree.addTeam(team);
    if (tree.type === 'Project') {
      SaveTreeAndSubtrees(tree);
    } else if (!isSavingProjectsAllowed) {
      SidebarService.updateSelectType('Text');
    } else if (UserAccount.isLoggedIn) {
      if (!autocreating && selectType === 'Text') tree.reportHasBeenViewed();
      CreateProject.createProject(tree, team);
    } else if (email && !isEmailInvalid(email)) {
      if (!autocreating && selectType === 'Text') tree.reportHasBeenViewed();
      CreateProject.registerAndCreateProject(tree, email, team);
    } else {
      this.setState({ submitEmail: true });
    }
  }
  updateState = () => {
    const { isLoggedIn } = UserAccount;
    const { selectType, saveOnShowReport } = SidebarService;
    const { skipToReport, loading } = this.state;
    this.state.selectType = selectType;
    Connect.sendIframeMessage({
      selectType,
    });
    const { tree } = GrayOut;
    if (!tree) return null;
    const { project } = tree;
    if (project && !loading && isLoggedIn) {
      if (selectType === 'Tree') tree.clearReportHasBeenViewed();
      else if (selectType === 'Text') tree.reportHasBeenViewed();
    }
    if (skipToReport && selectType === 'Text') {
      this.state.skipToReport = false;
    }
    if (selectType === 'Email' && saveOnShowReport) {
      if (isLoggedIn) {
        SidebarService.updateSelectType('Tree', true);
        this.saveChanges();
      } else {
        const email = tree.getReportSaveOnSubmitEmail();
        return this.saveChanges(email);
      }
    }
    if (selectType === 'Text' && saveOnShowReport) {
      const email = tree.getReportSaveOnSubmitEmail();
      return this.saveChanges(email);
    }
    return this.forceUpdate();
  }
  treeUpdated = () => {
    const { tree, loading, skipToReport } = this.state;
    if (!tree) return;
    AutoSaveTree.autoSaveProject(tree);

    if (loading) {
      if (tree.isBusy) {
        clearTimeout(this.waitTillLoadedTimeout);
        this.waitTillLoadedTimeout = null;
      } else if (!this.waitTillLoadedTimeout) {
        this.waitTillLoadedTimeout = setTimeout(() => {
          if (this.state.skipToReport) SidebarService.updateSelectType('Text');
          this.setState({ loading: false });
        }, skipToReport ? 1000 : 200);
      }
    }

    // Check for query parameters
    if (this.__checkQueryParametersTimeout) clearTimeout(this.__checkQueryParametersTimeout);
    this.__checkQueryParametersTimeout = setTimeout(() => {
      this.__checkQueryParametersTimeout = null;
      this.__checkQueryParameters();
    }, 100);
  }
  __checkQueryParameters = () => {
    const { tree } = this.state;
    if (!tree) return;
    const queryString = Navigation.currentSearch;
    const foundParameters = tree.updateQueryParameters(queryString);
    Array.from(foundParameters).forEach((p) => Navigation.getQueryParameter(p));
  }
  toggleFullscreen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    Connect.toggleFullscreen();
  }
  onRef = (e) => {
    if (!e || !Connect.__iframe) return;
    const { tree } = this.state;
    const { customSource } = tree;
    const customUrl = customSource && customSource.url;
    let finalUrl;
    let height = '100%';
    if (customUrl) {
      const { isImage, googleUrl, googleDriveUrl, youtubeUrl, loomUrl, airtableUrl, googleMapsUrl, canvaUrl, googleCalendarUrl, vimeoUrl, instagramEmbedCode, tiktokEmbedCode, isPDF } = checkContentType(customUrl);
      if (isImage) {
        const image = document.createElement('div');
        image.style.position = 'absolute';
        image.style.inset = '0';
        image.style.width = '100%';
        image.style.backgroundSize = 'contain';
        image.style.backgroundRepeat = 'no-repeat';
        image.style.backgroundPosition = 'center';
        image.style.backgroundImage = `url(${customUrl})`;
        e.appendChild(image);
        return;
      }

      // Change URL
      if (isPDF) finalUrl = `https://logictry.com/pdfjs/web/viewer.html?file=${encodeURIComponent(customUrl)}`;
      else if (airtableUrl === false) finalUrl = customUrl;
      else finalUrl = googleUrl || googleDriveUrl || youtubeUrl || loomUrl || googleMapsUrl || canvaUrl || googleCalendarUrl || vimeoUrl || instagramEmbedCode || tiktokEmbedCode || customUrl;

      // Handle special height if google spreadsheet to remove tabs
      if (googleUrl && googleUrl.includes("/spreadsheets/")) height = 'calc(100% + 26px)';
      if (googleMapsUrl) height = 'calc(100% + 75px)';
      if (airtableUrl) height = 'calc(100% + 24px)';

      // Add background color if Vimeo Video
      if (vimeoUrl) Connect.__iframe.style.backgroundColor = 'black';
      else if (googleDriveUrl) Connect.__iframe.style.backgroundColor = 'white';
      else Connect.__iframe.style.backgroundColor = null;

      if (googleUrl && googleUrl.includes('/pub?embedded=true')) {
        Connect.__iframe.style.maxWidth = '832px';
        Connect.__iframe.style.margin = 'auto';
      }
      if (instagramEmbedCode || tiktokEmbedCode) {
        Connect.__iframe.style.maxWidth = '600px';
        Connect.__iframe.style.margin = 'auto';
      }
      if (googleMapsUrl) {
        Connect.__iframe.style.top = '-60px';
      }
    } else {
      finalUrl = `${window.location.origin}/apps/${tree._id}${window.location.search}`;
    }
    Connect.__iframe.style.height = height;
    Connect.__iframe.src = finalUrl;
    e.appendChild(Connect.__iframe);
  }
  loggedOutSavePopupClosed = (success) => {
    const { saveOnShowReport } = SidebarService;
    const { tree, submitEmail } = this.state;
    const { isSavingProjectsAllowed } = tree;
    const goBackToForm = isSavingProjectsAllowed && saveOnShowReport && submitEmail;
    if (!success && goBackToForm) SidebarService.updateSelectType('Tree');
    return this.setState({ submitEmail: false });
  }
  successOK = () => this.setState({ submitEmail: false });
  render() {
    const { fullscreen, onScroll } = this.props;
    const { isApp, isWidget, isWidgetOnSameDomain } = Constants;
    const { isAuthorizedToLogIn } = Company;
    const { isLoggedIn } = UserAccount;
    const { mobile } = WindowSize;
    const { selectType, saveOnShowReport } = SidebarService;
    const { autocreating, tree, submitEmail, loading, chatbuttonShowContent, skipToReport } = this.state;
    if (!Constants.isLogicWiki && !this.treeIdToGet) return <FullScreenVerticalCenterContent alignTop={Constants.isWidget}><h1>App Not Found</h1></FullScreenVerticalCenterContent>;
    if (!tree || tree.loading) return <FullScreenVerticalCenterContent alignTop={Constants.isWidget} backgroundColor={backgroundColor || ''}><LoadingIndicator /></FullScreenVerticalCenterContent>;
    if (tree.error) {
      if (tree.error === 'PasswordIncorrect') return <EnterPassword />;
      return <FullScreenVerticalCenterContent><h1>App Not Found</h1></FullScreenVerticalCenterContent>;
    }

    if (isWidget && !Connect.isFullscreen && Navigation.currentSearch.showplaceholder === 'true') {
      return <div style={{ cursor: 'pointer' }} onClick={this.toggleFullscreen}>
        <img alt={'placeholder'} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }} src={getPlaceholderImage()}></img>
      </div>
    }

    if (autocreating) return <FullScreenVerticalCenterContent alignTop={Constants.isWidget} backgroundColor={backgroundColor || ''}><LoadingIndicator /></FullScreenVerticalCenterContent>;

    const showTree = selectType === 'Tree';
    const showChatbot = selectType === 'Chat';
    const showReport = selectType === 'Text';

    const { isOwnerOrAdmin, isLocked, project, isCustomApp, isSavingProjectsAllowed } = tree;
    const showSidebar = isLoggedIn && isApp && !mobile && !fullscreen && isAuthorizedToLogIn;
    const right = showSidebar ? 40 : 0;
    const runInIframe = isCustomApp || (!isWidget && (Navigation.currentSearch.iframe || findForceIframeContent(tree.root)));
    const editingVersionOfTree = TreeCache.getTree(tree._id, true);
    if (!editingVersionOfTree) return <FullScreenVerticalCenterContent alignTop={Constants.isWidget} backgroundColor={backgroundColor || ''}><LoadingIndicator /></FullScreenVerticalCenterContent>;
    const dontShowReportUntilSaved = isSavingProjectsAllowed && saveOnShowReport;
    const dontShowEmailUntilSaved = dontShowReportUntilSaved && submitEmail;
    const showRootProperty = !skipToReport && (showTree || (showReport && dontShowReportUntilSaved)) && tree.root;
    const showReportProperty = (skipToReport || showReport && tree.report);
    backgroundColor = isCustomApp && tree.background && tree.background.color || showRootProperty && tree.root.backgroundColor || showReportProperty && tree.report.backgroundColor;
    const backgroundImage = showRootProperty && tree.root.backgroundImage || showReportProperty && tree.report.backgroundImage;
    const backgroundVideo = showRootProperty && tree.root.backgroundVideo || showReportProperty && tree.report.backgroundVideo;
    const className = showRootProperty && 'logictry-root' || showReportProperty && 'logictry-report';
    const showYouAreNotAuthorizedToEdit = isLoggedIn && project && !isOwnerOrAdmin && showTree;
    const showLoginToEditYourSubmission = project && !isLoggedIn && showTree;
    const showProjectLocked = isLoggedIn && project && isOwnerOrAdmin && isLocked;
    const showDeleted = tree.isDeleted;
    const showLoginToView = !isLoggedIn && tree.shareSetting === 'LoggedInLinkView';
    const filter = showLoginToView && 'blur(6px) brightness(0.5)';
    const fontFamily = showRootProperty && tree.root.fontFamily || showReportProperty && tree.report.fontFamily;
    const fontSizeH1 = showRootProperty && tree.root.fontSizeH1 || showReportProperty && tree.report.fontSizeH1;
    const fontSizeH2 = showRootProperty && tree.root.fontSizeH2 || showReportProperty && tree.report.fontSizeH2;
    const fontSizeH3 = showRootProperty && tree.root.fontSizeH3 || showReportProperty && tree.report.fontSizeH3;
    const showButton = isWidget && !Connect.isFullscreen && Navigation.currentSearch.showbutton === 'true';
    const showToggle = (isCustomApp ? isCustomApp.endsWith('.pdf') : !tree.report.chatbot) && ((isWidget && Navigation.currentSearch.showtoggle !== 'false') || (!isWidget));
    const hideContentForChatbutton = showButton && !chatbuttonShowContent;

    if (showButton) Connect.setButtonExpanded(chatbuttonShowContent);
    const showBackArrow = isWidget && !isWidgetOnSameDomain && Constants.urlWithoutOrigin.startsWith('/collections/');
    const opacity = loading ? 0 : 1;

    const showReportChatbot = showReport && tree.report.chatbot && !dontShowReportUntilSaved;
    const hideContentWhenShowingChatbot = isWidget && !showButton && !Connect.isFullscreen && Navigation.currentSearch.autoresize !== 'false' && (showChatbot || showReportChatbot);
    if (hideContentWhenShowingChatbot) Connect.setHeightFullscreen();

    const contentStyle = {
      filter,
      right: showButton && 8 || right,
      top: showButton && 8 || null,
      bottom: showButton && 100 || null,
      left: showButton && 8 || null,
      boxShadow: showButton && 'rgba(0, 0, 0, 0.1) 0px 1px 4px, rgba(0, 0, 0, 0.2) 0px 2px 12px' || null,
      borderRadius: showButton && '0.5rem' || null
    };

    return (
      <>
        {showButton && <div
          onClick={() => this.setState({ chatbuttonShowContent: !chatbuttonShowContent })}
          style={{ cursor: 'pointer', width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', background: Constants.PrimaryColor, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 4px, rgba(0, 0, 0, 0.2) 0px 2px 12px', position: 'absolute', bottom: 32, right: 4 }}
        >
          <img alt="logictry" style={{ width: 32 }} src="https://logictrystatic.s3.us-east-1.amazonaws.com/images/icon_sharp_white.svg"></img>
        </div>}
        {!hideContentForChatbutton && <Wrapper
          onClick={this.handleClick}
          fontSizeH1={fontSizeH1}
          fontSizeH2={fontSizeH2}
          fontSizeH3={fontSizeH3}
          style={{ opacity, fontFamily }}
          key={`${tree.key}`}
        >
          {runInIframe && (
            <ContentWrapper
              style={{
                ...contentStyle,
                backgroundColor,
                backgroundImage: backgroundImage && `url(${backgroundImage})`
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: backgroundColor ? '1rem' : '0rem',
                  borderRadius: backgroundColor ? '0.5rem' : '0rem',
                  overflow: 'hidden'
                }}
                ref={this.onRef}
              ></div>
            </ContentWrapper>
          ) || (!hideContentWhenShowingChatbot) && <ContentWrapper
            style={{
              ...contentStyle,
              opacity: (showChatbot || showReportChatbot) ? 0 : 1
            }}
            className={className}
          >
            {backgroundColor && <div style={{ position: 'absolute', inset: 0, backgroundColor }}></div>}
            {backgroundImage && <ContentWrapper style={{ position: 'absolute', inset: 0, backgroundImage: backgroundImage && `url(${backgroundImage})` }}></ContentWrapper>}
            {backgroundVideo && <video style={{ objectFit: 'cover', position: 'absolute', inset: 0, width: '100%', height: '100%' }} autoPlay muted playsInline loop src={backgroundVideo}></video>}
            {((selectType === 'Email' && !dontShowEmailUntilSaved) && (
              <FullScreenVerticalCenterContent>
                <h1>Progress Saved</h1>
                <p>Follow the instructions in your email to continue your submission.</p>
              </FullScreenVerticalCenterContent>
            )) || ((showReport && !dontShowReportUntilSaved) && (
              <TextView saveChanges={this.saveChanges} onScroll={onScroll} />
            )) || (
              <TreeAnswerBox key={tree.key} tree={tree} saveProgress={this.saveProgress} onScroll={onScroll} />
            )}
          </ContentWrapper>}
          {(showTree || showChatbot) && <ChatInterface
            key={`${tree._id}_template`}
            tree={tree}
            style={{ ...contentStyle }}
            hide={!showChatbot}
          /> || (showReportChatbot) && <ChatInterface
            key={`${tree._id}_project`}
            report
            tree={tree}
            style={{ ...contentStyle }}
          />}
          {showDeleted && <EditingDisabled style={{ right }}><div>{project ? 'Submission' : 'App'} has been deleted</div></EditingDisabled>
          || showYouAreNotAuthorizedToEdit && <EditingDisabled style={{ right }}><div>You are not authorized to edit this submission</div></EditingDisabled>
          || showLoginToEditYourSubmission && <EditingDisabled style={{ right }}><div>Login to edit your submission</div></EditingDisabled>
          || showProjectLocked && <EditingDisabled style={{ right }}><div>Project Locked - Unlock to edit</div></EditingDisabled>}
          {isApp && !fullscreen && <Sidebar showMini={!showSidebar} tree={editingVersionOfTree} saveChanges={this.saveChanges} />}
          {showBackArrow && <BackArrowWrapper onClick={() => Navigation.back()} style={{ left: 8, padding: 6 }}>
            <ArrowLeftIcon style={{ width: 16, height: 16 }} />
          </BackArrowWrapper>}
          <EmbedFullscreenButton />
          {submitEmail && <LoggedOutSavePopup tree={tree} onClose={this.loggedOutSavePopupClosed} />}
        </Wrapper>}
        {!hideContentForChatbutton && !(showReport && !dontShowReportUntilSaved) && showToggle && !isWidgetOnSameDomain && <div
          style={{
            position: 'absolute',
            top: 8,
            left: showBackArrow ? 44 : 8,
            padding: 6,
            display: 'flex',
            alignItems: 'center',
            zIndex: 1,
            backgroundColor: 'white',
            borderRadius: '4px',
            boxShadow: 'rgba(0, 0, 0, 0.65) 0px 1px 5px',
            cursor: 'pointer',
            opacity
          }}
          onClick={() => SidebarService.updateSelectType(showChatbot ? 'Tree' : 'Chat')}
        >
          {showChatbot ? <TreeIcon style={{ width: 16, height: 16 }} /> : <ChatIcon style={{ width: 16, height: 16 }} />}
        </div>}
        {loading && <FullScreenVerticalCenterContent alignTop={Constants.isWidget} backgroundColor={backgroundColor || ''}><LoadingIndicator /></FullScreenVerticalCenterContent>}
        {showLoginToView && <div
          onClick={() => Navigation.push(Navigation.login)}
          style={{ position: 'absolute', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
        >
          <div style={{ color: 'white', padding: '1rem 2rem', borderRadius: '1rem', fontSize: Constants.SemiLargeFontSize, fontWeight: 'bold' }}>Login to view this content</div>
        </div>}
      </>
    );
  }
}
function getPlaceholderImage() {
  const ogImageMetaTag = document.querySelector('meta[property="og:image"]');
  const ogImageUrl = ogImageMetaTag ? ogImageMetaTag.getAttribute('content') : null;
  return ogImageUrl ? (ogImageUrl.includes('/v1/images') ? `${ogImageUrl}&width=${window.innerWidth}&height=${window.innerHeight}` : ogImageUrl) : null;
}
